var React = require('react');

function NpDashTopRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 2C2 202.443 214.031 571 692 571","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"4 10"}));
}

NpDashTopRight.defaultProps = {"width":"692","height":"573","viewBox":"0 0 692 573"};

module.exports = NpDashTopRight;

NpDashTopRight.default = NpDashTopRight;
